import Vue from 'vue'
import Router from 'vue-router'
import ThemeOne from '@/themes/theme-one'
import PrivacyPolicy from '@/components/InnerPages/PrivacyPolicy/PrivacyPolicy'
import DeleteAccount from '@/components/InnerPages/DeleteAccount/DeleteAccount'
import About from '@/components/InnerPages/About/About'
import Pricing from '@/components/InnerPages/Pricing/Pricing'
import Faq from '@/components/InnerPages/Faq/Faq'
import Contact from '@/components/InnerPages/Contact/Contact'
import AppDownload from '@/components/AppDownload/AppDownload'
import i18n from '@/i18n';
import routeDefinitions from './routes.json'

Vue.use(Router)

const SITE_URL = 'https://www.forwardreceipts.com'

function updateCanonicalUrl(route) {
  if (typeof document === 'undefined') {
    return
  }

  const path = route.path === '/' ? '/' : route.path.replace(/\/$/, '')
  const canonicalUrl = `${SITE_URL}${path}`
  let canonicalLink = document.querySelector('link[rel="canonical"]')

  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalLink)
  }

  canonicalLink.setAttribute('href', canonicalUrl)

  const ogUrl = document.querySelector('meta[property="og:url"]')
  if (ogUrl) {
    ogUrl.setAttribute('content', canonicalUrl)
  }
}

const routeComponents = {
  ThemeOne,
  PrivacyPolicy,
  DeleteAccount,
  About,
  Pricing,
  Faq,
  Contact,
  AppDownload
}

const router = new Router({
  mode: 'history',
  routes: routeDefinitions.map((route) => ({
    ...route,
    component: routeComponents[route.name]
  }))
})

router.beforeEach((to, from, next) => {
  const lang = to.query.lang

  if (['zh', 'en'].includes(lang)) {
    localStorage.setItem('preferred_lang', lang)
    i18n.locale = lang
  } else {
    i18n.locale = 'en'
  }

  next()
})

router.afterEach((to) => {
  updateCanonicalUrl(to)
})

export default router
